export default __webpack_public_path__ + "static/media/bg-upper-right-corner.fb533a63.svg";